module.exports = __webpack_public_path__ + "img/beams.cad9520.jpg";